import { render, staticRenderFns } from "./lightingIndex.vue?vue&type=template&id=6ca29e48&scoped=true"
import script from "./lightingIndex.vue?vue&type=script&lang=js"
export * from "./lightingIndex.vue?vue&type=script&lang=js"
import style0 from "../../../static/css/lightingIndex.css?vue&type=style&index=0&id=6ca29e48&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca29e48",
  null
  
)

export default component.exports